import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import ProjectFilledSvg from "@ant-design/icons-svg/es/asn/ProjectFilled";
import AntdIcon from "../components/AntdIcon";
var ProjectFilled = function ProjectFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ProjectFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  ProjectFilled.displayName = 'ProjectFilled';
}
export default /*#__PURE__*/React.forwardRef(ProjectFilled);